import SparePartsFinderProductSerialNumberIndexTableRow from './SparePartsFinderProductSerialNumberIndexTableRow';
import SparePartsFinderTextSearchIndexTable
    from '../spare-parts-finder-text-search/SparePartsFinderTextSearchIndexTable';

export default class SparePartsFinderProductSerialNumberIndexTable extends SparePartsFinderTextSearchIndexTable {
    static defaultProps = {
        features: []
    }

    rowComponentClass = SparePartsFinderProductSerialNumberIndexTableRow;
}
